import React from 'react';

export default function DataTable({ columns, data, pagination, onPageChange }) {
  const currentPage = pagination?.page || pagination?.currentPage || 1;
  const totalPages = pagination?.pages || pagination?.totalPages || 1;
  const totalRecords = pagination?.total || pagination?.totalRecords || 0;

  return (
    <div>
      <div className="table-container">
        <table>
          <thead>
            <tr>{columns.map((col, i) => <th key={i}>{col.header}</th>)}</tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((row, i) => (
                <tr key={row._id || i}>
                  {columns.map((col, j) => (
                    <td key={j}>{col.render ? col.render(row) : row[col.accessor]}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center text-muted p-2">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      {totalPages > 1 && (
        <div className="flex justify-between items-center text-sm text-muted mt-2 p-2" style={{ borderTop: '1px solid #eee' }}>
          <span>
            Page {currentPage} of {totalPages} 
            {totalRecords > 0 && <span className="ml-2">(Total: {totalRecords})</span>}
          </span>
          <div className="flex gap-1">
            {/* type="button" is CRITICAL to prevent form submission bugs */}
            <button 
              type="button"
              className="btn btn-sm btn-outline" 
              disabled={currentPage <= 1} 
              onClick={() => onPageChange(currentPage - 1)}
            >
              ← Prev
            </button>
            <button 
              type="button"
              className="btn btn-sm btn-outline" 
              disabled={currentPage >= totalPages} 
              onClick={() => onPageChange(currentPage + 1)}
            >
              Next →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}